var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',[_c('v-icon',{staticClass:"mx-1",staticStyle:{"vertical-align":"top"},attrs:{"small":"","color":_vm.color}},[_vm._v(" "+_vm._s(_vm.visible ? "fa-angle-double-up" : "fa-angle-double-down")+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }